var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.851 233H208.147C219.591 233 225.313 233 229.423 230.304C231.202 229.136 232.73 227.636 233.919 225.889C236.665 221.854 236.665 216.236 236.665 205C236.665 193.764 236.665 188.146 233.919 184.111C232.73 182.364 231.202 180.864 229.423 179.696C226.781 177.964 223.475 177.345 218.413 177.123C215.997 177.123 213.917 175.326 213.443 173C212.732 169.511 209.612 167 205.989 167H194.008C190.385 167 187.265 169.511 186.554 173C186.08 175.326 184 177.123 181.585 177.123C176.522 177.345 173.216 177.964 170.575 179.696C168.795 180.864 167.267 182.364 166.078 184.111C163.332 188.146 163.332 193.764 163.332 205C163.332 216.236 163.332 221.854 166.078 225.889C167.267 227.636 168.795 229.136 170.575 230.304C174.685 233 180.407 233 191.851 233ZM199.999 190C191.561 190 184.721 196.716 184.721 205C184.721 213.284 191.561 220 199.999 220C208.436 220 215.277 213.284 215.277 205C215.277 196.716 208.436 190 199.999 190ZM199.999 196C194.936 196 190.832 200.029 190.832 205C190.832 209.97 194.936 214 199.999 214C205.061 214 209.165 209.97 209.165 205C209.165 200.029 205.061 196 199.999 196ZM217.313 193C217.313 191.343 218.681 190 220.369 190H224.443C226.131 190 227.499 191.343 227.499 193C227.499 194.657 226.131 196 224.443 196H220.369C218.681 196 217.313 194.657 217.313 193Z",
    fill: "black",
    fillOpacity: 0.08
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholderWhite);
export default __webpack_public_path__ + "static/media/image-placeholder-white.b383606ad242d4df1242ba6b014e8807.svg";
export { ForwardRef as ReactComponent };